import singletonMysqlApis from 'src/services/IntanceMysqlApis';
import singletonAxios from 'src/services/IntanceAxios';
import { decodeToken } from 'react-jwt';
import singletonSession from 'src/services/IntanceSession';

const ClientId= '2758d422-8dff-4b47-9706-40559e829d47'
const realmId = '6c4c80bc-b84e-4c70-add3-6fc2f8803eed'
const services = {
    addRoleAdministrador(id) {
        return fetch(`/api/keycloak/users/${id}/role-realm`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
        }).then(res => res.json())
    },
    addUser(body) {
        return singletonMysqlApis.getInstance().post(`/users/addClient`, body)
    },
    addRole(body) {
        return singletonMysqlApis.getInstance().post(`/roles/addRole?clientID=${ClientId}`, body)
    },
    updateAttributeRole(idRol, body) {
        return singletonMysqlApis.getInstance().post(`/roles/updateRole?roleID=${idRol}`, body)
    },
    updateActivateUser(idUser, body) {
        return singletonMysqlApis.getInstance().put(`/users/update?userID=${idUser}`, body)
    },
    getRoleJusCreated(idRol) {
        return singletonMysqlApis.getInstance().get(`/roles/getRoleByID?clientID=${ClientId}&roleID=${idRol}`);
    },
    getUsersWithRolAssignedMysql() {
        return singletonMysqlApis.getInstance().get(`/users`)
    },
    getModulesByRolMysql() {
        return singletonMysqlApis.getInstance().get(`/roles`)
    },
    getPedidos(body) {
        return singletonMysqlApis.getInstance().post(`/pedidos`, body)
    },
    getPedidosInternos(body) {
        return singletonMysqlApis.getInstance().post(`/pedidosInternos`,  body)
    },
    deleteGuia(body){
        return singletonMysqlApis.getInstance().post(`/deleteGuia`, body)
    },
    addUserMysql(body) {
        return singletonMysqlApis.getInstance().post(`/cliente`, body)
    },
    editUserMysql(body) {
        return singletonMysqlApis.getInstance().put(`/edit/cliente`, body)
    },
    deleteUserMysql(body) {
        return singletonMysqlApis.getInstance().delete(`/delete/cliente`, {data: body})
    },
    getUsersMysql() {
        return singletonMysqlApis.getInstance().get(`/clientes`)
    },
    getAllProducts() {
        return singletonMysqlApis.getInstance().get('/inventario')
    },
    getAllTokens() {
        return singletonMysqlApis.getInstance().get(`/getAllTokens`)
    },
    getDate() {
        return singletonMysqlApis.getInstance().get(`/fecha`)
    },
    getUserTokens(body) {
        return singletonMysqlApis.getInstance().post(`/getUserTokens`, body)
    },
    deleteToken(body) {
        return singletonMysqlApis.getInstance().delete(`/deletetoken`, {data: body})
    },
    getRolesClient() {
        return singletonMysqlApis.getInstance().post(`/roles/getClient`, { ClientId })
    },
    getUsers() {
        return singletonAxios.getInstance()
          .get('/admin/realms/Icintracom/users')
    },
    getRolAssigedByUser() {
        return ""
    },
    getAttributesRoles(id) {
        return singletonMysqlApis.getInstance().get(`/roles/getAttributesRoles?roleID=${realmId}&userID=${id}`)
    },
    getRoleById(idUser) {
        return singletonMysqlApis.getInstance().get(`/roles/getMainUser?clientID=${ClientId}&userID=${idUser}`)
    },
    getAllRolesAssigned(idUser) {
        return singletonMysqlApis.getInstance()
          .get(`/roles/getRolesByUser?userID=${idUser}&clientID=${ClientId}`)
    },
    setRoleUser(idUser, body) {
        return singletonMysqlApis.getInstance().post(`/roles/setUser?clientID=${ClientId}&userID=${idUser}`, body)
    },
    setRoleRealm(idUser, body) {
        return singletonMysqlApis.getInstance().post(`/roles/setUser?clientID=${realmId}&userID=${idUser}`, body)
    },
    deleteRole(idRol) {
        return singletonMysqlApis.getInstance().delete(`/roles/delete?roleID=${idRol}`)
    },
    deleteUser(idUser) {
        return singletonMysqlApis.getInstance().delete(`/users/delete?userID=${idUser}`)
    },
    deleteRolAssigned(idUser, body) {
        return singletonMysqlApis.getInstance().delete(`/roles/deleteRoleByUser?userID=${idUser}&clientID=${ClientId}`
          , {data: body})
    },
    resetPassword(idUser, body) {
        return singletonMysqlApis.getInstance().put(`/users/resetPassword?userID=${idUser}`, body)
    },
    updateUser(idUser, body) {
        return singletonAxios.getInstance().put(`/admin/realms/Icintracom/users/${idUser}`, body)
    },
    deleteTokenSession: async function () {
        try {
            const token = window.localStorage.getItem("session");
            if (!token) {
                return;
            }

            const decoded = decodeToken(token);
            const body = {
                Username: decoded.username,
                AccessUuid: decoded.access_uuid
            };

            await this.deleteToken(body);

            window.localStorage.clear();
            singletonSession.instance = null;

        } catch (error) {
            console.error("Error cerrando sesión:", error);
        }
    }
}

export default services;
